module.exports = __webpack_public_path__ + "img/52.6dc7b011.png";